import { render } from "./Object.vue?vue&type=template&id=604f22a2&scoped=true"
import script from "./Object.vue?vue&type=script&lang=js"
export * from "./Object.vue?vue&type=script&lang=js"

import "./Object.vue?vue&type=style&index=0&id=604f22a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-604f22a2"

export default script